const featureRequestThumbs = document.querySelectorAll('.feature-request-thumb');

featureRequestThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
        const featureId = thumb.dataset.featureRequestId;
        const voteType = thumb.classList.contains('thumbs-up') ? 'up' : 'down';
        const voteCount = parseInt(thumb.textContent.trim());
        const voted = thumb.classList.contains('voted');

        fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `action=indamed_feature_request_thumbs&feature_id=${featureId}&vote_type=${voteType}`,
        })
            .then(response => response.json())
            .catch(error => alert('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'));

        if (voteType === 'up') {
            thumb.textContent = voted ? voteCount - 1 : voteCount + 1;
            thumb.classList.toggle('voted');

            const thumbsDown = document.querySelectorAll(`.feature-request-thumb[data-feature-request-id="${featureId}"].thumbs-down`);

            thumbsDown.forEach(thumbDown => {
                if (thumbDown.classList.contains('voted')) {
                    thumbDown.textContent = parseInt(thumbDown.textContent.trim()) - 1;
                    thumbDown.classList.remove('voted');
                }
            });
        } else if (voteType === 'down') {
            thumb.textContent = voted ? voteCount - 1 : voteCount + 1;
            thumb.classList.toggle('voted');

            const thumbsUp = document.querySelectorAll(`.feature-request-thumb[data-feature-request-id="${featureId}"].thumbs-up`);

            thumbsUp.forEach(thumbUp => {
                if (thumbUp.classList.contains('voted')) {
                    thumbUp.textContent = parseInt(thumbUp.textContent.trim()) - 1;
                    thumbUp.classList.remove('voted');
                }
            });
        }
    });
});